export default __webpack_public_path__ + "static/media/faq.9303cf52.jpg";